
import i18n from "../i18n/i18n";
import { updateLangue } from "../pages/userapp/ServiceUserApp";
const STORAGE_KEY = "APP_LANGUAGE";

export const getLanguage = () => {return localStorage.getItem(STORAGE_KEY) || "FR";

};

export const saveLanguageLocal = (lang) => {
    localStorage.setItem(STORAGE_KEY, lang);
    i18n.changeLanguage(lang.toLowerCase());

};


export const initializeLanguage = () => {
    const lang = getLanguage();
    i18n.changeLanguage(lang.toLowerCase());
    return lang;
};


export const changeLanguage = async (userId, lang) => {

    saveLanguageLocal(lang);

    if (!userId)
        return;

    try {

        const response = await updateLangue(userId, lang);

        console.log("LANGUE SAUVEE :", response.data);

        return response.data;

    }
    catch(error){

        console.log(error.response);

        throw error;

    }

};